/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded",function(){var t=document.querySelectorAll(".text-accordion");t.length&&t.forEach(function(t){var n=t.querySelector(".image-with-text__text--caption"),e=[];if(n){n.classList.add("accordion-title"),n.addEventListener("click",function(){var n=t.classList.toggle("accordion-open");e.forEach(function(t){t.style.maxHeight=n?t.scrollHeight+"px":null})});for(var i=n.nextElementSibling;i;)e.push(i),i.classList.add("content"),i.style.maxHeight=null,i.style.transition="max-height 0.3s ease-out",i=i.nextElementSibling}})});


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
